import React from 'react';
import { MentoringReport } from '@/components/meetings/MentoringReport';

export default function MentoringReports() {
  return (
    <div className="container mx-auto py-8 px-4">
      <div className="mb-8">
        <h1 className="text-3xl font-bold">Mentoring Reports</h1>
        <p className="text-muted-foreground mt-2">
          Track mentoring, coaching, and observation minutes with detailed analytics and trends.
        </p>
      </div>
      
      <MentoringReport />
    </div>
  );
}